import React, { useState, useEffect } from "react";
import "../../../assets/styles/local/UserVerification.css";
import { userVerifySignup } from "../../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import companyLogo from "../../../assets/icons/CompanyLogo.png";

const UserVerification = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { userid } = useParams();
  const [verify, setVerify] = useState(false);

  console.log("asc56", userid);

  const userVerificationRes = useSelector(
    (state) => state.user.userVerificationRes
  );

  useEffect(() => {
    if (userid && userVerificationRes.status === true) {
      setVerify(true);
      localStorage.setItem("userVerified", "yes");
      setTimeout(() => {
        history.push(`/MakeNewPassword/${userid}`);
        window.location.reload();
      }, 2000);
    }
  }, [userVerificationRes]);

  return (
    <div className="varMain">
      <div className="varSecMainDiv">
        <div className="">
          <img src={companyLogo} alt="Logo" className="varimgLogo" />
        </div>

        <div className="py-4 pt-lg-0 varUnderTxt">
          <p>Welcome !</p>

          <p
            className={
              verify
                ? "varUnderTxtSuccess animate__animated animate__flipInX pt-3"
                : "varUnderTxt pt-3"
            }
            style={{ height: "75px", width: "350px" }}
          >
            {verify
              ? "Your email address has been successfully verified."
              : "Please verify your email address."}
          </p>

          <p className="txt2" style={{ width: "350px" }}>
            Please wait for further instructions to be sent to your inbox. You
            will receive login instructions shortly.
          </p>

          <p className="txt2">Thank you for verifying your email address.</p>

          <button
            className="varButton w-100"
            onClick={() => {
              dispatch(userVerifySignup(userid));
              localStorage.setItem("userVerified", "yes");
            }}
          >
            Verify
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserVerification;
